<template>
  <div class="d-flex align-items-center justify-content-between">
    <div class="mr-3">
      <label class="input-group">
        <span class="input-group-prepend"><span class="input-group-text">От</span></span>
        <input type="number" v-model="input.min" class="form-control" :placeholder="fromPlaceholder" min="0">
      </label>
    </div>
    <div>
      <label class="input-group">
        <span class="input-group-prepend"><span class="input-group-text">До</span></span>
        <input type="number" v-model="input.max" class="form-control" :placeholder="toPlaceholder" min="0">
      </label>
    </div>
  </div>
</template>

<script>
  import { assign, mapValues, pickBy, omitBy, debounce, isString, isFinite, isNumber } from 'lodash'

  function emptyRange () {
    return { min: null, max: null }
  }

  export default {
    props: {
      range: { type: Object, default: emptyRange },
      value: { type: Object, default: emptyRange },
    },
    data () {
      return {
        input: assign(emptyRange(), this.value),
      }
    },
    computed: {
      preparedInput () {
        const strings = pickBy(this.input, (value) => ((isString(value) && value.length) || isFinite(value)))
        return omitBy(mapValues(strings, parseFloat), isNaN)
      },
      precision () {
        const precision = 2
        return Math.pow(10, precision)
      },
      fromPlaceholder () {
        if (!isNumber(this.range.min)) {
          return this.range.min
        }
        return Math.round(this.range.min * this.precision) / this.precision
      },
      toPlaceholder () {
        if (!isNumber(this.range.max)) {
          return this.range.max
        }
        return Math.round(this.range.max * this.precision) / this.precision
      },
    },
    methods: {
      update: debounce(function () {
        this.$emit('input', this.preparedInput)
      }, 250),
    },
    watch: {
      value (val) {
        this.input.min = val.min
        this.input.max = val.max
      },
      input: {
        handler () {
          this.update()
        },
        deep: true,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-range.vue